// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/~/core-js/library/modules/$.to-integer.js
// module id = 308
// module chunks = 0